import { EitherOneRequiredBadge, RequiredBadge } from './RequiredBadge';

const Label = (props) => {
    const { type, className, style, isRequired, isEitherOneRequired } = props;

    if (type === 'column') {
        return (
            <label className={`${className}`} style={style}>
                {props.text}
                {isRequired && <RequiredBadge />}
                {isEitherOneRequired && <EitherOneRequiredBadge />}
            </label>
        );
    }

    return (
        <label className="form-group__label">
            <span className="form-group__label-text">
                {props.text}
                {isRequired && <RequiredBadge />}
                {isEitherOneRequired && <EitherOneRequiredBadge />}
            </span>
        </label>
    );
};

export default Label;
